export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const topFilesColumns = [
  { title: 'Document Id', value: 'documentId' },
  { title: 'Downloads', value: 'downloads' },
  { title: 'Average Consumption', value: 'consumption' },
];
export const channelsColumns = [
  { title: 'Channel', value: 'channel' },
  { title: 'Subchannel', value: 'subchannel' },
  { title: 'Users', value: 'userCount' },
  { title: 'Downloads', value: 'documentCount' },
];
export const topUsersColumns = [
  { title: 'User Id', value: 'userId' },
  { title: 'Unique Files', value: 'uniqueFiles' },
  { title: 'Total Downloads', value: 'downloads' },
];
export const skeletonRows = [1, 2, 3, 4];

export const getVisitorsChartData = (months: string[], data: number[]) => ({
  labels: months,
  datasets: [
    {
      label: 'Unique Visitors',
      backgroundColor: '#335153',
      borderColor: 'rgba(0,0,0,1)',
      borderWidth: 0,
      barThickness: 20,
      data,
    },
  ],
});

export const getDocumentChartData = (months: string[], data: number[]) => ({
  labels: months,
  datasets: [
    {
      label: 'Documents',
      backgroundColor: '#335153',
      borderColor: 'rgba(0,0,0,1)',
      borderWidth: 0,
      barThickness: 20,
      data,
    },
  ],
});

export const getChannelAndSubchannelQueries = (channels: string[], subchannels: string[]) => {
  let channelsQuery = '';
  let subchannelsQuery = '';

  channels.forEach((c) => (channelsQuery += `&channel=${c}`));
  subchannels.forEach((c) => (subchannelsQuery += `&channel=${c}`));
  return [channelsQuery, subchannelsQuery];
};

/**
 *  function that takes care of adding a leading zero if the minutes or seconds only contain a single digit (are less than 10).
 * @param num given number (minutes or seconds)
 * @returns double digit number
 */
const padTo2Digits = (num: number): string => {
  return num.toString().padStart(2, '0');
};

/**
 *
 * @param duration given seconds
 * @returns formated duration value ( double digit ) MM:SS
 */
export const getDurationFormatedValue = (duration: number): string => {
  // get number of full minutes
  const minutes = Math.floor(duration / 60);

  // get remainder of seconds
  const seconds = duration % 60;

  // format as MM:SS
  const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
  return result;
};


// convert UTC date to local date in string format MM/dd/yyyy, hh:mm:ss
export const formatOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour12: false,
};

export const sortArrayAtoZ = (array: any[]) => {
  array?.sort((a, b) => {
    const alpha = a!.id!.toUpperCase();
    const beta = b!.id!.toUpperCase();
    return alpha < beta ? -1 : alpha > beta ? 1 : 0;
  });
};

export const getExtensionOfFile = (inputString: string): string => {
  if(inputString!==undefined){
    const lastDotIndex = inputString.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      const substringAfterLastDot = inputString.substring(lastDotIndex + 1);
      return substringAfterLastDot;
    } else {
      return '';
    }
  }
  return '';
}
